import React, { useContext } from 'react';
import { SubscriptionClient } from 'subscriptions-transport-ws';

const backendSubscriptionClientContext = React.createContext<SubscriptionClient | undefined>(
    undefined
);

export const BackendSubscriptionClientProvider = backendSubscriptionClientContext.Provider;
export const BackendSubscriptionClientConsumer = backendSubscriptionClientContext.Consumer;

export function useBackendSubscriptionClient(): SubscriptionClient | undefined {
    return useContext(backendSubscriptionClientContext);
}
